import styled from 'styled-components';

export const Container = styled.div`
  cursor: pointer;

  &:hover {
    .title {
      color: #185335;
    }
  }

  .img {
    width: 100%;
    height: 160px;
    background-position: center;
    background-size: cover;
    margin-bottom: 10px;
    background-image: url(${({ src }) => src});
  }

  .title {
    font-weight: bold;
    font-size: 1.1rem;
  }
`;
